import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: 'http://8.130.14.101:60000/api',
  timeout: 100000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['X-Token'] = token
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 如果是Blob类型（文件下载），直接返回
    if (res instanceof Blob) {
      return res
    }
    // 如果返回的消息包含"拒绝授权"，替换为更友好的提示
    if (res && res.msg && res.msg.includes('拒绝授权')) {
      res.msg = '账号已下线，请重新登录'
    }
    return res
  },
  error => {
    console.log('err' + error)
    return Promise.reject(error)
  }
)

// 封装GET请求
export function getAction(url, params) {
  return service({
    url: url,
    method: 'get',
    params
  })
}

// 封装GET请求（Blob下载）
export function getBlobAction(url, params) {
  return service({
    url: url,
    method: 'get',
    responseType: 'blob',
    timeout: 6000000,
    params
  })
}

// 封装POST请求
export function postAction(url, data) {
  return service({
    url: url,
    method: 'post',
    data
  })
}

export default service
